<script setup>
import Avatar from 'dashboard/components-next/avatar/Avatar.vue';

defineProps({
  id: { type: Number, required: true },
  name: { type: String, default: '' },
  email: { type: String, default: '' },
  phoneNumber: { type: String, default: '' },
  thumbnail: { type: String, default: '' },
  additionalAttributes: { type: Object, default: () => ({}) },
});

const emit = defineEmits(['click']);
</script>

<template>
  <div
    class="flex flex-col gap-2 p-3 bg-n-solid-2 border border-n-weak rounded-lg cursor-pointer hover:border-n-slate-6"
    @click="emit('click', id)"
  >
    <div class="flex items-center gap-2">
      <Avatar :name="name" :src="thumbnail" :size="24" />
      <span class="text-sm font-medium truncate text-n-slate-12">
        {{ name }}
      </span>
    </div>
    <div
      v-if="additionalAttributes?.companyName"
      class="text-xs truncate text-n-slate-11"
    >
      {{ additionalAttributes.companyName }}
    </div>
    <div v-if="email" class="text-xs truncate text-n-slate-11">
      {{ email }}
    </div>
    <div v-if="phoneNumber" class="text-xs truncate text-n-slate-11">
      {{ phoneNumber }}
    </div>
  </div>
</template>
